/**
 * Order Details
 */

// React
import React, { useState, useContext } from 'react';

// Context
import AuthContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid, Button, Divider, CircularProgress } from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPostOutline,
  mdiCityVariant,
  mdiPackageVariant,
  mdiMessageProcessingOutline,
  mdiCubeSend,
} from '@mdi/js';

// Components

// Rules

// Helper
import {
  formaterPhoneNumber,
  translate,
} from '../../utils/helpers';

// Type
import { Payload, Status } from '../orders/interfaces';
import { OrderDetail, SelectorPostProps } from './interfaces';
import { Link } from 'react-router-dom';
import { mdiCity, mdiBank, mdiWeightKilogram } from '@mdi/js/commonjs/mdi';
import { createStructuredSelector } from 'reselect';
import { Store } from '../../redux/reducers';
import { makeSelectError, makeSelectLoading } from '../orders/selectors';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { makeSelectPostOrder } from '../orders/selectors';
import { createPostOrderAction } from '../orders/actions';
import Can from '../../components/Can';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    link: {
      textDecoration: 'none !important',
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function Details(props: OrderDetail) {
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const classes = useStyles();

  const getBarcode = () => {
    const { id } = props.order;
    props.createPostOrderDispatch({
      id,
      body: {
        send: true,
      },
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام سفارش‌دهنده:  '}
              </span>

              <span>{props.order.customerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شماره موبایل:  '}
              </span>
              <span>
                {formaterPhoneNumber(props.order.customerPhoneNumber)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCityVariant} size={1} className={classes.icon} />
                {' استان :  '}
              </span>
              <span>
                {props.order.customerProvince && props.order.postProvince}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCity} size={1} className={classes.icon} />
                {'شهر:  '}
              </span>
              <span>{props.order.customerCity && props.order.postCity}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {' تاریخ تحویل :  '}
              </span>
              <span>
                {props.order.deliveryDate && props.order.deliveryDate}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPostOutline} size={1} className={classes.icon} />
                {' کد پستی :  '}
              </span>
              <span>
                {props.order.customerZipCode && props.order.customerZipCode}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {'آدرس سفارش‌دهنده:  '}
              </span>
              <span>
                {props.order.customerAddress && props.order.customerAddress}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCubeSend} size={1} className={classes.icon} />
                {'نوع ارسال:  '}
              </span>
              <span>
                {props.order.serviceType &&
                  translate(props.order.serviceType, 'service')}
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiBank} size={1} className={classes.icon} />
                {'نوع بیمه:  '}
              </span>
              <span>
                {props.order.insuranceType &&
                  translate(props.order.insuranceType, 'insurance')}
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMessageProcessingOutline}
                  size={1}
                  className={classes.icon}
                />
                {'سرویس پیامک:  '}
              </span>
              <span>{props.order.smsService ? 'بلی' : 'خیر'}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {'نوع بسته:  '}
              </span>
              <span>
                {props.order.parcelType &&
                  translate(props.order.parcelType, 'parcel')}
              </span>
            </div>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiWeightKilogram}
                  size={1}
                  className={classes.icon}
                />
                {'وزن دقیق:  '}
              </span>
              <span>{props.order.weight && props.order.weight}</span>
            </div>
          </Grid>

          <Grid
            style={{ marginTop: '40px' }}
            item
            container
            justify="flex-end"
            xs={12}
          >
            <Grid container item justify="flex-end" spacing={2} xs={12}>
              <Grid item>
                <Can
                  role={authContext.user.role}
                  perform="/post-orders-queue"
                  yes={() => (
                    <Link className={classes.link} to="/post-orders-queue">
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="secondary"
                        size="large"
                        data-cy="search"
                      // disabled={props.loading}
                      >
                        {`تایید و ارسال به صف`}
                      </Button>
                    </Link>
                  )}
                />
              </Grid>
              <Grid item>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  className={classes.link}
                  color="secondary"
                  size="large"
                  data-cy="search"
                  disabled={props.loading}
                  onClick={() => getBarcode()}
                >
                  {`تایید و دریافت بارکد`}{' '}
                  {props.loading && <CircularProgress size={24} />}
                </Button>
              </Grid>
              <Grid item>
                {props.postOrder?.barcode && (
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    className={classes.link}
                    color="secondary"
                    size="large"
                    data-cy="search"
                    disabled={!props.postOrder?.barcode || props.loading}
                    onClick={() => {
                      const win = window.open(
                        `/post-print-labels/${props.order.id}`,
                        '_blank'
                      )!;
                      win.focus();
                    }}
                  >
                    {`چاپ بارکد`}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPostProps>({
  postOrder: makeSelectPostOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    createPostOrderDispatch: (payload: Payload) =>
      dispatch(createPostOrderAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
